// extracted by mini-css-extract-plugin
module.exports = {"cardmsgD":"cardmsgD_cardmsgD__hPOdL","cardmsgD1":"cardmsgD_cardmsgD1__g0_IV","cardmsgD2":"cardmsgD_cardmsgD2__7DQ7e"};